import { render, staticRenderFns } from "./flags_empty.vue?vue&type=template&id=afd713c8&scoped=true&"
import script from "./flags_empty.vue?vue&type=script&lang=js&"
export * from "./flags_empty.vue?vue&type=script&lang=js&"
import style0 from "./flags_empty.vue?vue&type=style&index=0&id=afd713c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd713c8",
  null
  
)

export default component.exports